module.exports = __webpack_public_path__ + "static/media/FujiInstaxMini3.39by2.13.8d45bcb7.png";